var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-km",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h416.25v416.25H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    transform: "scale(1.23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M0 0h625v104.06H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 104.06h625v104.06H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be0027",
    d: "M0 208.12h625v104.06H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b5aa3",
    d: "M0 312.19h625v104.06H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v416.238l310.45-207.533L0 0z",
    fill: "#239e46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.81 114.98c-69.183-3.51-100.7 51.6-100.63 94.2-.159 50.38 47.582 91.93 91.71 89.43-23.794-11.26-52.85-42.82-53.117-89.64-.244-42.423 23.977-79.31 62.038-93.99z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M126.77 160.21l-9.75-7.63-11.82 3.72 4.24-11.64-7.18-10.09 12.38.43 7.37-9.95 3.41 11.91 11.75 3.94-10.28 6.93zm-.207 42.327l-9.75-7.63-11.82 3.72 4.24-11.64-7.18-10.09 12.38.43 7.37-9.95 3.41 11.91 11.75 3.94-10.28 6.93zm.207 42.742l-9.75-7.63-11.82 3.72 4.24-11.64-7.18-10.09 12.38.43 7.37-9.95 3.41 11.91 11.75 3.94-10.28 6.93zm-.207 43.161l-9.75-7.63-11.82 3.72 4.24-11.64-7.18-10.09 12.38.43 7.37-9.95 3.41 11.91 11.75 3.94-10.28 6.93z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKm);
export default __webpack_public_path__ + "static/media/km.4fb5c60d977cdce0c8bbb6359527c128.svg";
export { ForwardRef as ReactComponent };